<template>
  <div v-if="isActivated">
    <b-col class="p-0" :class="{ pleineLargeur: pleineLargeur }">
      <b-row class="d-lg-none position-relative menu-haut m-0">
        <b-col class="position-absolute fleche-retour p-0">
          <Hyperlien
            :content="{
              texte: '',
              type: 'lienPrimaire',
              lien: { field: 'precedent' },
              urlRetour: '/casino/accueil',
            }"
            class="h-100"
          />
        </b-col>
      </b-row>
      <b-row
        v-if="isJeuLance || isJeuLanceModeDemo"
        class="m-0 position-relative d-flex justify-content-center jeu-lance"
      >
        <div v-if="produit.videoSnapshotBG">
          <b-img :src="produit.videoSnapshotBG" :alt="produit.name" class="image-ced h-100 w-100" />
        </div>
        <MediaImageFocalPoint
          v-else
          :content="{
            formatRatio: $isMobile() ? '1x1' : '16x9',
            image: produit.image,
          }"
          class="w-100"
        />
        <!-- Ajout bouton fermerJeu avec Modale de confirmation -->
        <div id="btn-fermer-jeu" class="btn-close d-flex justify-content-end">
          <b-button class="btn" @click="afficherMessageFermetureJeu()">
            <svg-icon class="svg-icone" icon-name="ic-fermer"></svg-icon>
          </b-button>
          <!-- Modale de confirmation du choix de fermeture du jeu -->
          <ModaleConfirmerChoix
            v-show="isModaleFermetureJeuVisible"
            :content="contentModaleConfirmQuitterJeu"
            @confirm="fermerJeu()"
            @cancel="fermerModaleFermetureJeu()"
          />
        </div>
        <iframe
          v-if="!isJelMobile"
          id="jeu-iframe"
          :title="produit.name"
          :src="getUrl()"
          class="h-100 position-absolute border-0"
          @load="cacherMenu()"
        ></iframe>
      </b-row>
      <b-row v-else class="m-0 background-jeu">
        <div class="w-100">
          <b-img
            v-if="produit.videoSnapshotBG"
            :src="produit.videoSnapshotBG"
            :alt="produit.name"
            class="image-ced w-100"
          />
          <div
            class="w-100 banniere-container"
            :class="{
              'banniere-active':
                isProduitDesactive ||
                messageDesactivation ||
                isLotProgressif ||
                isProduitMASEnDirect,
            }"
          >
            <MediaImageX3 :show="true" :content="contentMediaImageX3" :preloadForAnimation="true" />
          </div>

          <div class="w-100">
            <div :class="{ 'disabled-overlay': isProduitDesactive }"></div>
            <div
              class="banniere-progressif"
              :class="[
                isProduitDesactive || messageDesactivation
                  ? 'desactive'
                  : { actif: isLotProgressif },
                { mas: isProduitMASEnDirect },
              ]"
            >
              <CarteInfoSecondaireDesactivation
                v-if="isProduitDesactive || messageDesactivation"
                :content="{ texteDesactivation: messageDesactivation }"
              />
              <BanniereInfoLotProgressif
                v-else-if="isLotProgressif"
                :content="{ produit: produit, isListeHorizontale: false }"
                class="px-2"
              />
              <BanniereInfoMASEnDirect
                v-else-if="isProduitMASEnDirect"
                :content="{
                  produit: produit,
                }"
              />
            </div>
          </div>
        </div>
      </b-row>
      <div class="bg-white d-flex justify-content-center menu-jeu">
        <b-row class="barre-options border-top border-bottom w-100 px-2 m-0">
          <b-col cols="4" class="d-none d-lg-flex justify-content-start align-items-center mh-100">
            <Hyperlien :content="hyperlienRetour" class="graphik_semibold hyperlien-retour" />
          </b-col>
          <b-col
            class="text-md-center d-flex justify-content-start justify-content-lg-center align-items-center themeAccent px-2"
            :cols="jel_isEcranDesktop($mq) ? 4 : isDisponibleAppareil ? 7 : 12"
          >
            <template v-if="isDisponibleAppareil">
              <span @click.capture="gaPreventClickJouer('jouer')">
                <b-button
                  v-show="!isJeuLance || isJeuLanceModeDemo"
                  class="w-md-auto hauteur px-4 py-1 bouton-jouer"
                  :class="[isProduitDesactive ? 'btn-produit-desactive' : 'btn-primaire']"
                  :disabled="isProduitDesactive"
                  @click="
                    isJeuLanceModeDemo ? confirmerChangerModeJeu() : lancerJeu((mode = 'jouer'))
                  "
                  v-html="getTexteBoutonJouer"
                />
              </span>
              <span @click.capture="gaPreventClickJouer('demo')">
                <b-link
                  v-show="isDemoDisponible && !isJeuLanceModeDemo"
                  class="graphik_medium caption-2 mode-gratuit lienAsset pr-0 ml-2"
                  :class="{ desactive: isProduitDesactive }"
                  :disabled="isProduitDesactive"
                  @click="isJeuLance ? confirmerChangerModeJeu() : lancerJeu((mode = 'demo'))"
                >
                  {{
                    $t('messageComponent.modeDemo') +
                    (isJeuLance ? $t('messageComponent.modeDemoJeuLance') : '')
                  }}
                </b-link>
              </span>
            </template>
            <div v-else class="modale-information-jeu">{{ indisponibleAppareil }}</div>
            <!-- Modale information Jeu -->
            <ModaleInformation
              v-show="isModaleInfoJeuVisible"
              :content="contentModaleInformationJeu"
              @close="fermerModaleInformationJeu()"
            />
            <!-- Modale information erreur lancement Jeu -->
            <ModaleInformation
              v-show="isModaleErreurVisible"
              :content="contentModaleErreurLancementJeu"
              @close="fermerModaleErreur()"
            />
            <!-- Modale confirmation choix changement de mode de Jeu -->
            <ModaleConfirmerChoix
              v-show="isModaleConfirmChangeModeVisible"
              :content="contentModaleConfirmChangeModeJeu"
              @confirm="lancerJeu((mode = isJeuLanceModeDemo ? 'jouer' : 'demo'), true)"
              @cancel="fermerModaleConfirmerMode()"
            />
            <!-- Modale information Jeu MAS en direct -->
            <ModaleInformationJeuMASEnDirect
              v-show="isModaleInfoJeuMASEnDirectVisible"
              :content="contentModaleInformationJeuMASEnDirect"
              @confirmer="fermerModaleMASEnDirect()"
              @annuler="lancerJeuMASenDirect()"
            />
          </b-col>
          <b-col
            v-if="isDisponibleAppareil"
            class="d-flex align-items-center justify-content-end px-2"
            :cols="jel_isEcranDesktop($mq) ? 4 : 5"
          >
            <span @click.capture="gaPreventClick('favori')">
              <button
                :aria-label="isConsentant ? '' : $t('messageComponent.texteConsentement')"
                class="bouton-icone tooltip-favoris"
                @click="toggleFavori()"
              >
                <svg-icon
                  class="taille-icone"
                  :class="{ 'loi-25': !isConsentant }"
                  :icon-name="isFavori ? 'icone-favori-noir' : 'icone-favori'"
                />
                <span v-if="!isConsentant" class="erreur">
                  <svg-icon icon-name="icone-avertissement" />
                </span>
                <span v-if="!isConsentant" aria-hidden="true" class="tooltip-favoris-text">
                  {{ $t('messageComponent.texteConsentement') }}&nbsp;<a
                    href="javascript:Didomi.reset();Didomi.preferences.show()"
                    target="_self"
                    class="lien-didomi"
                    >{{ $t('messageComponent.texteLienConsentement') }}</a
                  >
                </span>
              </button>
            </span>
            <!-- Mis en commentaire parce que on ne la livrera pas dans la version 1  -->
            <!-- <svg-icon class="taille-icone ml-3" icon-name="icone-like" /> -->
            <div v-if="!isProduitDesactive" class="d-none d-xxl-flex ml-3">
              <span @click.capture="gaPreventClick('pleineLargeur')">
                <button class="bouton-icone" @click="modePleineLargeur()">
                  <svg-icon class="taille-icone cursor-pointer" icon-name="icone-theatre" />
                </button>
              </span>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-col>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import platform from 'platform';
import qs from 'qs';
import axios from 'axios';
import { debounce } from 'lodash';
import i18n from '@/js/i18n';
import { bus } from '@/main';

// Helpers
import { isJelMobile, getQueryParamsValue, postToUrl } from '@/helpers/AppHelpers';
import { gtmCustomEventByVendor } from '@/helpers/ConsentHelpers';

// Components
// Base components
import Hyperlien from '@/components/base/Hyperlien';
import MediaImageX3 from '@/components/media/image/MediaImageX3';
import MediaImageFocalPoint from '@/components/media/image/MediaImageFocalPoint';
// Casino components
import BanniereInfoLotProgressif from '@/components/casino/carte/BanniereInfoLotProgressif.vue';
import BanniereInfoMASEnDirect from '@/components/casino/carte/BanniereInfoMASEnDirect';
import CarteInfoSecondaireDesactivation from '@/components/casino/carte/CarteInfoSecondaireDesactivation';
// Modals Components
import ModaleConfirmerChoix from '@/components/casino/modals/ModaleConfirmerChoix';
import ModaleInformation from '@/components/casino/modals/ModaleInformation';
import ModaleInformationJeuMASEnDirect from '@/components/casino/modals/ModaleInformationJeuMASEnDirect';

// Mixins
import mixinProduitCasino from '@/mixins/casino/mixinProduitCasino';

// Services
import session from '@/services/api/compte/session';

export default {
  name: 'JeuCasinoJouer',
  components: {
    Hyperlien,
    MediaImageX3,
    MediaImageFocalPoint,
    BanniereInfoLotProgressif,
    BanniereInfoMASEnDirect,
    CarteInfoSecondaireDesactivation,
    ModaleConfirmerChoix,
    ModaleInformation,
    ModaleInformationJeuMASEnDirect,
  },
  mixins: [mixinProduitCasino],
  props: {
    produit: { type: Object, required: true },
    lienRetour: { type: Object, required: true },
  },
  i18n: {
    messages: {
      fr: {
        messageComponent: {
          modeDemo: 'Essayer',
          modeDemoJeuLance: ' le jeu',
          texteConsentement:
            'Pour ajouter des jeux à vos favoris, vous devez accepter tous les témoins de personnalisation.',
          texteLienConsentement: 'Gestion des témoins',
        },
      },
      en: {
        messageComponent: {
          modeDemo: 'Try out',
          modeDemoJeuLance: ' the game',
          texteConsentement:
            'To add games to your favourites, you must accept all personalization cookies.',
          texteLienConsentement: 'Manage cookies',
        },
      },
    },
  },
  data() {
    return {
      isActivated: true,
      isJeuLance: false,
      isJeuLanceModeDemo: false,
      isToggleFavori: false,
      isModaleInfoJeuVisible: false,
      isModaleInfoJeuMASEnDirectVisible: false,
      isModaleConfirmChangeModeVisible: false,
      isModaleErreurVisible: false,
      isModaleFermetureJeuVisible: false,
      mode: null,
      modeDemo: null,
      pleineLargeur: false,
      connexionBoutonJouer: false,
      connexionOuverturePage: false,
      isJelMobile: isJelMobile(),
      isModaleVisible: false,
      langueJeux: '',
      modaleInformationJeu: {
        titre: null,
        message: null,
      },
      masquerModaleMasEnDirect: false,
    };
  },
  computed: {
    ...mapGetters({
      fournisseurGetByUuid: 'fournisseur/getByUuid',
      integrateurGetByUuid: 'integrateur/getByUuid',
      getStatutProduit: 'produitCasino/getStatutProduit',
      getStatutIntegrateur: 'integrateur/getStatutIntegrateur',
      profileIsFavori: 'preferences/isFavori',
    }),
    isLotProgressif() {
      return (this.produit && this.produit.idProgressif) ?? false;
    },
    isProduitMASEnDirect() {
      return (
        (this.produit &&
          this.produit.categorie == 'mas' &&
          this.produit.typeJeu == 'masEnDirect' &&
          this.produit.image4 &&
          this.produit.image4['@name']) ??
        false
      );
    },
    isMASEnDirect() {
      const integrateur = this.integrateurGetByUuid(this.produit.integrateur);
      return integrateur && integrateur['@name'] == 'winafar';
    },
    isModaleMASEnDirectVisible() {
      return this.isMASEnDirect && this.afficherModaleMASEnDirect;
    },
    contentMediaImageX3() {
      const content = this.produit;
      content.formatRatio = this.$isMobile() ? '1x1' : '16x9';
      content.altImage = content.name;
      content.altImage2 = content.name;
      content.altImage3 = content.name;

      if (!content.image) {
        content.image = this.$store.state.produitCasino.imageDefaut;
      }
      return content;
    },
    produitDesactivation() {
      const produitDesactive = this.produit
        ? this.getStatutProduit(this.produit, isJelMobile())
        : false;
      return produitDesactive;
    },
    isProduitDesactive() {
      return this.produit ? this.produitDesactivation?.indDesactive : false;
    },
    integrateurProduitDesactivation() {
      const integrateurDesactive = this.produit
        ? this.getStatutIntegrateur(this.produit.integrateur, isJelMobile())
        : false;
      return integrateurDesactive;
    },
    isIntegrateurProduitDesactive() {
      return this.integrateurProduitDesactivation?.indDesactive;
    },
    messageDesactivation() {
      if (this.isIntegrateurProduitDesactive) {
        return undefined;
      }
      if (this.isProduitDesactive) {
        return this.produit.txtDesactivation;
      }
      if (this.produitDesactivation?.message) {
        return this.produit.txtDesactivation;
      }
      return undefined;
    },

    idFamille() {
      // Si on a 2 paramètres (famille/produit) alors on a une famille (CED)
      return this.$route.params.param2 ? this.$route.params.param1 : null;
    },
    isDisponibleAppareil() {
      return (
        this.idFamille ||
        (isJelMobile() && this.produit.indMobile == 'true') ||
        (!isJelMobile() && this.produit.indInternet == 'true')
      );
    },
    isFavori() {
      return this.profileIsFavori(this.produit);
    },
    indisponibleAppareil() {
      return i18n.t('casino.informationJeu.indisponibleAppareil');
    },
    msgTournerTelephone() {
      return i18n.t('casino.informationJeu.tournerTelephone');
    },
    isDemoDisponible() {
      if (isJelMobile()) {
        return this.produit.demoMobile == 'true';
      }
      return this.produit.demoInternet == 'true';
    },
    getTexteBoutonJouer() {
      return `${this.$t(
        'jouer'
      )} <span class='sr-only'>${this.mixinProduitCasino_getTitre()}</span>`;
    },
    hyperlienRetour() {
      return {
        texte: this.lienRetour.libelle,
        type: 'lienTertiaire',
        lien: {
          ...this.lienRetour.lien,
          nomIcone: 'fleche-droite-mini-lien',
          positionImage: 'gauche',
          cssIcone: 'rotation180',
        },
        urlRetour: '/casino/accueil',
      };
    },
    contentModaleInformationJeu() {
      const message = this.mixinProduitCasino_getMessage();
      return {
        idHTML: 'information-jeu',
        titre:
          this.jel_replaceTokens(this.produit.infoFenetreTitre) ?? // Titre modale saisi dans Magnolia
          i18n.t('casino.informationJeu.titreModale'),
        message: message.fenetre,
        libBoutonContinuer: i18n.t('casino.informationJeu.btnContinuer'),
      };
    },
    contentModaleConfirmQuitterJeu() {
      return {
        idHTML: 'fermer-jeu',
        titre: i18n.t('casino.quitterJeu.titreModale'),
        libBtnConfirm: i18n.t('casino.quitterJeu.confirmer'),
        libBtnCancel: i18n.t('casino.quitterJeu.annuler'),
      };
    },
    contentModaleErreurLancementJeu() {
      return {
        idHTML: 'erreur-jeu',
        titre: this.modaleInformationJeu.titre,
        message: this.modaleInformationJeu.message,
        libBoutonContinuer: i18n.t('casino.informationJeu.btnContinuer'),
      };
    },
    contentModaleInformationJeuMASEnDirect() {
      return {
        idHTML: 'information-masendirect',
        titre: i18n.t('casino.masEnDirect.titreModale'),
        message: i18n.t('casino.masEnDirect.messageModale'),
        libBoutonConfirmer: i18n.t('casino.masEnDirect.confirmer'),
        libBoutonAnnuler: i18n.t('casino.masEnDirect.annuler'),
        nePlusVoirMessage: i18n.t('casino.masEnDirect.nePlusVoirMessage'),
      };
    },
    contentModaleConfirmChangeModeJeu() {
      if (this.isJeuLance) {
        return {
          idHTML: 'confirmer-mode-jeu-jouer',
          titre: '',
          message: this.$t('casino.modeJeu.titreModeReel'),
          libBtnConfirm: this.$t('casino.modeJeu.confirmerReel'),
          libBtnCancel: this.$t('casino.modeJeu.annulerReel'),
        };
      }
      return {
        idHTML: 'confirmer-mode-jeu-demo',
        titre: '',
        message: this.$t('casino.modeJeu.titreModeFictif'),
        libBtnConfirm: this.$t('casino.modeJeu.confirmerFictif'),
        libBtnCancel: this.$t('casino.modeJeu.annulerFictif'),
      };
    },
    isConsentant() {
      return this.$store.state.consentement.consentement.preferences;
    },
  },
  mounted() {
    document.addEventListener('ejEventLogin', this.ejLoginEventListener);
    // Query Param mode: valeurs possibles : (jouer|demo)
    this.mode = getQueryParamsValue('mode');
    if (getQueryParamsValue('toggleFavori') === 'true') {
      this.isToggleFavori = true;
      this.toggleFavori();
      this.supprimerUrlParams();
    }
    if (this.mode) {
      if (isJelMobile()) {
        if (['lancer', 'real'].includes(this.mode)) {
          this.mode = 'jouer';
          this.ajouterUrlParamsMode(this.mode);
          this.lancerJeu(this.mode);
        } else if (this.mode == 'jouer' || this.mode == 'lancerDemo') {
          if (this.mode == 'lancerDemo') {
            this.mode = 'demo';
          }
          this.supprimerUrlParams();
          this.lancerJeu(this.mode);
        }
      } else {
        if (this.mode !== 'demo') {
          this.supprimerUrlParams();
          this.mode = 'jouer';
        }
        this.ajouterUrlParamsMode(this.mode);
        this.lancerJeu(this.mode);
      }
    }
  },
  created() {
    window.addEventListener('resize', this.resizeEventHandler);
    bus.$on('changeWidth', (data) => {
      if (this.isJeuLance || this.isJeuLanceModeDemo) {
        this.repositionnerBoutonFermerJeu();
      }
    });
    // 1 clic max par seconde sur le bouton favori
    this.toggleFavori = debounce(this.toggleFavori, 1000);
  },
  destroyed() {
    window.removeEventListener('resize', this.resizeEventHandler);
    bus.$off('changeWidth');
  },
  beforeDestroy() {
    document.removeEventListener('ejEventLogin', this.ejLoginEventListener);
  },
  activated() {
    this.isActivated = true;
  },
  deactivated() {
    if (this.$isMobile()) {
      bus.$emit('afficherMenuBas', true);
    }
    this.isJeuLance = false;
    this.isJeuLanceModeDemo = false;
    this.isActivated = false;
  },
  methods: {
    isSessionOuverte() {
      return session.sessionEstOuverte();
    },
    gaPreventClick(param = null, evt = null) {
      let event = '';
      let categorie = '';
      let libelle = '';

      // On récupère le titre du Jeu
      const titreProduit = this.$i18n.locale !== 'en' ? this.produit.titreFr : this.produit.titreEn;
      if (param == 'favori') {
        event = 'ga-bf-click';
        categorie = 'BF - Bouton favori';
        libelle += `Toggle Favori - ${titreProduit}`;
      } else if (param == 'pleineLargeur') {
        event = 'ga-bpl-click';
        categorie = 'BPL - Bouton pleine largeur';
        libelle += `Toggle Ecran pleine largeur - ${titreProduit}`;
      }
      const emplacement = `${this.jel_gaGetEmplacement()} ${titreProduit}`;

      // Ajout datalayer pour ajouter statistiques Event click vers Google Analytics
      gtmCustomEventByVendor(process.env.VUE_APP_IAB_ID_ANALYTICS, {
        event,
        categorie,
        emplacement,
        libelle,
      });
    },
    gaPreventClickJouer(mode = null, evt = null) {
      let event = '';
      let categorie = '';
      let libelle = '';

      // On récupère le titre du Jeu
      const titreProduit = this.$i18n.locale !== 'en' ? this.produit.titreFr : this.produit.titreEn;
      const emplacement = `${this.jel_gaGetEmplacement()} ${titreProduit}`;
      if (mode == 'jouer') {
        event = 'ga-bmj-click';
        categorie = 'BMJ - Bouton mode jouer';
        libelle += `${this.$t('jouer')} ${titreProduit}`;
      } else {
        event = 'ga-bmg-click';
        categorie = 'BMG - Bouton mode gratuit';
        libelle += `${
          this.$t('messageComponent.modeDemo') +
          (this.isJeuLance ? this.$t('messageComponent.modeDemoJeuLance') : '')
        } ${titreProduit}`;
      }

      // Ajout datalayer pour ajouter statistiques Event click vers Google Analytics
      gtmCustomEventByVendor(process.env.VUE_APP_IAB_ID_ANALYTICS, {
        event,
        categorie,
        emplacement: `${this.jel_gaGetEmplacement()} ${titreProduit}`,
        libelle,
      });
    },
    isModeDemo() {
      this.modeDemo = getQueryParamsValue('mode') == 'demo';
      return this.modeDemo;
    },
    changerMode() {
      if (this.produitDesactivation && !this.produitDesactivation.indDesactive) {
        this.modeDemo = !this.modeDemo;
        this.ajouterUrlParamsMode(this.mode);
      }
    },
    cacherMenu() {
      if (
        this.$isMobile() &&
        (window.innerWidth < 576 ||
          (window.innerHeight < 576 && window.innerWidth > window.innerHeight))
      ) {
        // ScreenOrientation n'est pas supporté sur Safari
        if (platform.name == 'Safari') {
          if (Math.abs(window.orientation) == 90) {
            bus.$emit('afficherMenuBas', false);
          }
          window.onorientationchange = () => {
            bus.$emit('afficherMenuBas', Math.abs(window.orientation) == 0);
          };
        } else {
          if (
            ['landscape-primary', 'landscape-secondary'].includes(window.screen.orientation.type)
          ) {
            bus.$emit('afficherMenuBas', false);
          }
          window.screen.orientation.onchange = () => {
            bus.$emit(
              'afficherMenuBas',
              ['portrait-primary', 'portrait-secondary'].includes(window.screen.orientation.type)
            );
          };
        }
      } else {
        this.repositionnerBoutonFermerJeu();
      }
    },
    modePleineLargeur() {
      if (!this.produitDesactivation.indDesactive) {
        this.pleineLargeur = !this.pleineLargeur;
        bus.$emit('pleineLargeur', this.pleineLargeur);
        setTimeout(this.repositionnerBoutonFermerJeu, 100);
      }
    },
    getUrl() {
      /**
       * On récupère le fournisseur du produit
       * pour identifier le fournisseur 'winafar' des jeux MAS en direct
       * */
      const integrateur = this.integrateurGetByUuid(this.produit.integrateur);
      const channel = this.$isMobile() ? 'M' : 'I';
      const desktopMobileLangue = isJelMobile()
        ? this.produit.langueMobile
        : this.produit.langueInternet;
      if (desktopMobileLangue.includes(i18n.locale)) {
        this.langueJeux = i18n.locale;
      } else {
        this.langueJeux = desktopMobileLangue;
      }

      if (integrateur['@name'] == 'agl') {
        return this.getUrlAGLJeu();
      }
      if (integrateur['@name'] == 'ogslivecasino') {
        return this.getUrlLiveCasinoJeu(channel);
      }
      if (integrateur['@name'] == 'winafar') {
        return this.getUrlMASEnDirectJeu(channel);
      }
      if (isJelMobile()) {
        return `/gcm-ws/gamelaunch/${this.produit.idJeu}`;
      }
      return this.getUrlDefautJeu(channel);
    },

    getUrlDefautJeu(channel) {
      const url = '/portal_api/game/launch';
      const mode = this.isModeDemo() ? 'demo' : 'real';
      const urlParams = new URLSearchParams();
      urlParams.set('lang', this.langueJeux);
      urlParams.set('gameName', this.produit.idJeu);
      urlParams.set('channel', channel);
      urlParams.set('playMode', mode);
      // TODO: 'desktop' pour tous? À valider
      urlParams.set('device', 'desktop');
      // TODO: voir si c'est pertinant d'avoir le flash
      urlParams.set('clientType', 'html5');
      return `${url}?${urlParams}`;
    },
    getUrlAGLJeu() {
      const mode = this.isModeDemo() ? 'demo' : 'play';
      return `${
        process.env.VUE_APP_LOTERIES_DOMAIN +
        i18n.t('casino.informationJeu.jeuxExperience') +
        this.produit.idJeu
      }/${mode}`;
    },
    getUrlLiveCasinoJeu(channel) {
      const url = '/portal_api/livecasino/launch';
      const urlParams = new URLSearchParams();
      urlParams.set('lang', this.langueJeux);
      urlParams.set('gameName', this.produit.idJeu);
      urlParams.set('channel', channel);
      // TODO: Ajouter tableId pour CED
      // if (typeof tableId !== "undefined") {
      //   url += "&tableId=" + tableId;
      // }
      return `${url}?${urlParams}`;
    },
    getUrlMASEnDirectJeu(channel) {
      const url = '/portal_api/liveslots/launch';
      const urlParams = new URLSearchParams();
      urlParams.set('lang', this.langueJeux);
      urlParams.set('channel', channel);
      return `${url}?${urlParams}`;
    },

    async lancerJeu(mode = null, bypassNonBloquant = null) {
      if (mode) {
        this.mode = mode;
      }
      this.connexionBoutonJouer = true;
      if (this.isProduitDesactive) {
        this.supprimerUrlParams();
      } else if (this.verifierSessionOuverte()) {
        if (this.isJeuLance || this.isJeuLanceModeDemo) {
          this.fermerModaleConfirmerMode();
          await this.fermerJeu();
        }
        if (
          !this.produitDesactivation.indDesactive &&
          !this.produitDesactivation.indBloquant &&
          (!this.produitDesactivation.indNonBloquant || bypassNonBloquant)
        ) {
          if (this.isMASEnDirect) {
            if (!this.isPopupInLocalStorage()) {
              /**
               * Si le popup 'winafarpopup' n'existe pas dans le LocalStorage
               * alors Ouvrir modale pour info avant de lancer le jeu MAS en direct
               * Sinon, on lance le jeu
               * */
              this.isModaleInfoJeuMASEnDirectVisible = true;
              this.$bvModal.show('information-masendirect');
            } else {
              this.lancerJeuMASenDirect();
            }
          } else {
            if (this.mode == 'demo') {
              this.changerMode();
            }
            if (isJelMobile()) {
              await this.lancerJeuMobile(mode);
            } else if (this.mode == 'jouer') {
              this.isJeuLanceModeDemo = false;
              this.isJeuLance = true;
              this.ajouterUrlParamsMode(this.mode);
            } else {
              this.isJeuLance = false;
              this.isJeuLanceModeDemo = true;
            }
          }
          this.$store.dispatch('preferences/setPreferenceJoueRecemment', this.produit);
        } else {
          this.isModaleInfoJeuVisible = true;
          this.afficherMessageModal();
        }
      }
    },
    async lancerJeuMobile(mode) {
      const uri = await this.getUrl();
      if (uri.startsWith('/gcm-ws')) {
        const params = {
          channel: 'M',
          lang: this.langueJeux,
          // eslint-disable-next-line prettier/prettier
          playMode: (mode === 'demo') || this.isModeDemo() ? 'demo' : 'real',
        };
        axios
          .post(uri, qs.stringify(params))
          .then((response) => {
            this.handleLaunchResponse(response.data);
          })
          .catch((error) => {
            this.modaleInformationJeu.titre = i18n.t('casino.desactivation.fenetreMessage');
            this.modaleInformationJeu.message = i18n.t('casino.desactivation.erreurLancementJeu');
            if (!this.isModaleVisible) {
              this.isModaleVisible = true;
              this.$bvModal.show('erreur-jeu');
            }
          });
      } else {
        // TODO: verifier si on lance en plein écran
        window.open(uri, '_blank', 'width=800, height=711, resizable=yes, menubar=no, status=no');
      }
    },
    handleLaunchResponse(xmlResponse) {
      let launchURL = xmlResponse.GameUrl;
      // pass extra information to common ui: language and referer page (target on back arrow press)
      launchURL = launchURL.replace(
        'gcmParams=',
        `gcmParams=lang%3D${i18n.locale}%7Creferer%3D${window.location.pathname
          .split('/')
          .join('%2F')}%7C`
      );
      // also pass language to game
      launchURL = `${launchURL}&lang=${i18n.locale}`;
      if (launchURL.indexOf('gcmParams') === -1) {
        /* pour lancer les jeux 1x2 à partir d'une collection on a 2x le
         *  mode le deuxième en français cause problème il lance le jeu
         *  en mode demo
         */
        if (launchURL.indexOf('mode') > 0) {
          this.supprimerUrlParams();
        }
        launchURL = `${launchURL}&lobbyurl=${encodeURIComponent(window.location.href)}`;
      }
      const urlMethodNode = xmlResponse.GameUrlMethod;
      if (urlMethodNode && urlMethodNode == 'POST') {
        // extract url post params
        let params = {};
        const postDataNode = xmlResponse.GamePostData;
        if (postDataNode) {
          params = postDataNode.Param.reduce((map, obj) => {
            map[obj.name] = obj.value;
            return map;
          }, {});
        }
        postToUrl(launchURL, params);
      } else {
        // Redirect to the game URL returned from the gameLaunch web service response
        window.location.href = launchURL;
      }
    },
    afficherMessageModal() {
      this.isModaleInfoJeuVisible = true;
      this.$bvModal.show('information-jeu');
    },
    fermerModaleInformationJeu() {
      this.isModaleInfoJeuVisible = false;
      this.$bvModal.hide('information-jeu');
      if (!this.produitDesactivation.indBloquant) {
        // this.ajouterUrlParamsMode(this.mode);
        this.lancerJeu(this.mode, true);
      }
    },
    confirmerChangerModeJeu() {
      this.isModaleConfirmChangeModeVisible = true;
      this.afficherModaleConfirmerMode();
    },
    afficherModaleConfirmerMode() {
      this.isModaleConfirmChangeModeVisible = true;
      if (this.isSessionOuverte()) {
        if (this.isJeuLance) {
          this.$bvModal.show('confirmer-mode-jeu-jouer');
        } else {
          this.$bvModal.show('confirmer-mode-jeu-demo');
        }
      }
    },
    fermerModaleConfirmerMode() {
      this.isModaleConfirmChangeModeVisible = false;
      if (this.isJeuLance) {
        this.$bvModal.hide('confirmer-mode-jeu-jouer');
      } else {
        this.$bvModal.hide('confirmer-mode-jeu-demo');
      }
    },
    fermerJeu() {
      this.supprimerUrlParams();
      this.isJeuLance = false;
      this.isJeuLanceModeDemo = false;
      if (this.isModaleFermetureJeuVisible) {
        this.fermerModaleFermetureJeu();
      }
    },
    afficherMessageFermetureJeu() {
      this.isModaleFermetureJeuVisible = true;
      this.$bvModal.show('fermer-jeu');
    },
    fermerModaleFermetureJeu() {
      this.isModaleFermetureJeuVisible = false;
      this.$bvModal.hide('fermer-jeu');
    },
    fermerModaleErreur() {
      this.isModaleErreurVisible = false;
      this.$bvModal.hide('erreur-jeu');
    },
    // Vérifier existence popup MAS en Direct dans le LocalStorage
    isPopupInLocalStorage() {
      return window.localStorage.getItem('winafarpopup') == 'true';
    },
    fermerModaleMASEnDirect() {
      this.isModaleInfoJeuMASEnDirectVisible = false;
      this.$bvModal.hide('information-masendirect');
      // Redirection vers page explicative Jeu MAS en direct
      window.location.href = this.jel_nettoyerLienExterne(
        i18n.t('casino.masEnDirect.urlPageInformation')
      );
    },
    async lancerJeuMASenDirect() {
      if (this.isModaleInfoJeuMASEnDirectVisible) {
        this.isModaleInfoJeuMASEnDirectVisible = false;
        this.$bvModal.hide('information-masendirect');
      }
      const uri = await this.getUrl();
      // Lancer le jeu
      // TODO: verifier si on lance en plein écran
      window.open(uri, '_blank', 'width=800, height=711, resizable=yes, menubar=no, status=no');
    },
    verifierSessionOuverte(toggleFavori = null) {
      if (this.isSessionOuverte()) {
        return true;
      }

      try {
        // On test si le bouton de connexion Auth0 est actif
        if (process.env.VUE_APP_CIAM_ENABLED === 'true') {
          window.history.replaceState(
            {},
            '',
            `${window.location.origin}${window.location.pathname}`
          );
          const urlParams = new URLSearchParams(window.location.search);
          if (this.mode) {
            urlParams.set('mode', this.mode);
          }
          if (toggleFavori) {
            urlParams.set('toggleFavori', toggleFavori);
          }
          let retrunUrl = window.location.href;
          if (urlParams.size > 0) {
            retrunUrl = `${window.location.href}?${urlParams}`;
          }
          // eslint-disable-next-line no-undef
          lancerConnexionAuth0(this.$i18n.locale, retrunUrl);
        } else {
          // eslint-disable-next-line no-undef
          ejConnect.ouvrirModaleLogin();
        }
      } catch (error) {
        console.error("Erreur à l'ouverture de la page de connexion", error);
      }
      this.isJeuLance = false;
      this.isJeuLanceModeDemo = false;
      return false;
    },
    ejLoginEventListener() {
      if (this.connexionBoutonJouer || this.connexionOuverturePage) {
        this.connexionBoutonJouer = false;
        this.connexionOuverturePage = false;
        if (!getQueryParamsValue('mode')) {
          if (this.mode == 'demo' && this.isJelMobile) {
            this.ajouterUrlParamsMode('lancerDemo');
          } else {
            this.ajouterUrlParamsMode(this.mode);
          }
        }
      }
      if (this.isToggleFavori) {
        this.toggleFavori();
      }
    },
    // Sinon bloqué par le navigation guard en utilisant this.$router
    ajouterUrlParamsMode(mode) {
      const urlParams = new URLSearchParams(window.location.search);
      urlParams.set('mode', mode);
      window.history.replaceState({}, '', `${window.location.pathname}?${urlParams}`);
    },
    supprimerUrlParams() {
      const urlParams = new URLSearchParams(window.location.search);
      urlParams.delete('mode');
      urlParams.delete('toggleFavori');
      window.history.replaceState({}, '', `${window.location.pathname}`);
    },
    toggleFavori() {
      if (this.isConsentant && this.verifierSessionOuverte(true)) {
        this.$store.dispatch('preferences/togglePreferenceFavori', {
          produit: this.produit,
          isToggledApresConnexion: this.isToggleFavori,
        });
        this.isToggleFavori = false;
      } else {
        this.isToggleFavori = true;
      }
    },
    repositionnerBoutonFermerJeu() {
      const margeDroite = 32;
      const targetIframe = document.getElementById('jeu-iframe');
      const btnFermerJeu = document.getElementById('btn-fermer-jeu');
      if (btnFermerJeu) {
        const btnClose = btnFermerJeu.getElementsByClassName('btn')[0];

        // Si le iframe rempli tout l'espace du parent, il faut le rappetisser pour laisser de la place au bouton de fermeture à droite
        if (targetIframe.offsetWidth + margeDroite * 2 >= targetIframe.parentElement.clientWidth) {
          targetIframe.style.width = `${
            targetIframe.parentElement.clientWidth - margeDroite * 2
          }px`;
        } else {
          targetIframe.style.width = '100%';
        }

        btnClose.style.left = `${targetIframe.offsetLeft + targetIframe.offsetWidth}px`;
      }
    },
    resizeEventHandler(e) {
      if (this.isJeuLance || this.isJeuLanceModeDemo) {
        // parfois le iframe se resize en retard j'ai donc ajouté un petit délais d'une fraction de seconde
        setTimeout(this.repositionnerBoutonFermerJeu, 100);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$height-banniere: 60px;

button.btn,
.btn {
  margin-bottom: 0 !important;
}

.background-jeu {
  background-color: black;
}

.banniere-container,
.disabled-overlay {
  height: 375px;
  @include media-breakpoint-up(lg) {
    height: 400px;
  }
  @include media-breakpoint-up(lg) {
    height: 500px;
  }
  &.banniere-active {
    @include media-breakpoint-down(xs) {
      height: 375px - $height-banniere;
    }
  }
}

.disabled-overlay {
  position: absolute;
  width: 100%;
  top: 0;
  background: #ffffff;
  opacity: 0.8;
}

.barre-options {
  color: $noir-casino;
  min-height: 52px;
  padding-left: 0px !important;
  padding-right: 0px !important;
  ::v-deep {
    .lienPrimaire {
      font-size: $font-size-7;
      display: block;
      text-decoration: none;
      color: $couleur-bleu-fonce-lq;
      &::before,
      &:hover::before,
      &:active::before,
      &:focus::before {
        content: '\276E';
        padding-right: 1rem;
        display: inline-flex;
      }
    }
    .boutonPrimaire {
      margin: 0;
    }
  }
  .mode {
    width: min-content;
    font-size: 0.8125rem;
    line-height: 0.8125rem;
    text-transform: uppercase;
  }
  ::v-deep .btn {
    border-radius: 2rem;
  }
}

#jeu-iframe {
  width: 100%;
}

.jeu-lance {
  padding-bottom: 100%;
  background: #060606;
  .chargement {
    background: rgba(0, 0, 0, 0.3);
    color: #fff;
    .titre-chargement {
      font-size: 1.25rem;
    }
  }
  @media only screen and (max-width: 647px) and (orientation: portrait) {
    padding-bottom: 0;
    iframe {
      display: none;
    }
    .chargement {
      display: block;
    }
  }
  @media only screen and (max-width: 647px) and (orientation: landscape) {
    iframe {
      display: block;
    }
    .chargement {
      display: none;
    }
  }
}

.taille-icone {
  transform: scale(2.75);
}
.mode-gratuit {
  letter-spacing: $letter-spacing-n1;
  &.desactive {
    opacity: 0.65;
  }
}
.fleche-retour {
  font-size: $font-size-6;
  line-height: $line-height-6;
  height: 3rem;
  width: 3rem;
  z-index: 1;
  > div {
    ::v-deep .lienPrimaire {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      width: 100%;
      text-decoration: none;
      color: #fff;
      background: rgba(0, 0, 0, 0.55);
    }
  }
}
@include media-breakpoint-down(sm) {
  div img.image-ced {
    height: 100vw;
    object-fit: cover;
  }
}
@include media-breakpoint-up(md) {
  .jeu-lance {
    padding-bottom: 700px;
    height: 0;
    overflow: hidden;
    iframe {
      max-height: 700px;
      max-width: 106.66vh;
    }
    > div {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      filter: brightness(0.3);
      ::v-deep img,
      img {
        width: 100%;
        object-fit: cover;
      }
    }
    > div::v-deep button,
    .btn-close {
      position: absolute;
      top: 0;
      right: 0;
      filter: brightness(1);
    }
  }
}
@include media-breakpoint-up(xl) {
  .proprietes-jeu {
    .titreJeu {
      font-size: 2rem;
    }
  }
  .pleineLargeur {
    .jeu-lance {
      padding-bottom: 0;
      height: 700px;
    }
    div:nth-child(2) > div {
      max-height: 700px;
      overflow: hidden;
    }
  }
}
.baniere-container {
  position: relative;
}
.banniere-progressif {
  width: 40%;
  &.desactive,
  &.actif {
    height: $height-banniere;
    @include media-breakpoint-up(sm) {
      margin-top: -60px;
    }
  }
  &.desactive {
    @include media-breakpoint-up(sm) {
      position: absolute;
    }
    ::v-deep {
      .jeu-non-disponible {
        margin-top: 0.15rem !important;
        font-size: 1.125rem;
      }
      .de-retour-bientot {
        margin-bottom: 0 !important;
        line-height: $line-height-4;
        font-size: 0.813rem;
      }
    }
  }
  &.mas {
    height: $height-banniere;
    @include media-breakpoint-up(sm) {
      margin-top: -60px;
    }
  }
}

@include media-breakpoint-down(sm) {
  .banniere-progressif {
    width: 60%;
  }
}
.couleur-fond {
  border-top-right-radius: 10px;
}

.btn-produit-desactive {
  color: #070707 !important;
  background-color: #f7f7f7 !important;
  border-color: $couleur-bouton-theme-clair;
  border-width: 2px 2px 5px 2px;
}
.produitDesactive {
  opacity: 0.6;
}
.menu-jeu {
  height: 60px;
}
::v-deep .focal-point.logo {
  height: 100%;
}
@include media-breakpoint-down(xs) {
  .banniere-progressif {
    width: 100%;
  }
  .couleur-fond {
    border-top-right-radius: 0px;
  }
}
.btn-close {
  right: 0;
  top: 0;
  cursor: pointer;
  button.btn {
    position: absolute;
    width: 2rem;
    height: 2rem;
  }
  .btn {
    border: none;
    background-color: transparent;
    padding: 0;
    height: 1rem;
    line-height: 1rem;
    cursor: pointer;
    svg {
      color: #152665;
      font-size: 1.5rem;
      width: 2rem;
      height: 2rem;
    }
  }
}
.bouton-jouer {
  margin-top: -2px;
}
.bouton-icone {
  border: none;
  background: none;
  margin: -6px -8px;
  padding: 6px 8px;
  border-radius: 4px;
  &:focus-visible {
    outline: none;
    background-color: $bleu-pale-casino;
  }
}
.modale-information-jeu {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 18px;
}
.loi-25 {
  color: #bdbdbd;
  opacity: 0.5;
}
.erreur {
  position: absolute;
  z-index: 1;
  top: 0;
  left: -12px;

  color: #ffbc06;
  border-radius: 12px;
  padding: 2px 6px 2px 6px;
}

.tooltip-favoris {
  position: relative;
  display: inline-block;

  .tooltip-favoris-text {
    position: absolute;
    z-index: 1;

    width: 250px;
    padding: 5px;
    right: 0;
    top: 100%;
    visibility: hidden;

    background-color: #fff9e6;
    border: 1px solid #ffbc06;
    font-family: $font-graphik-regular;
    font-size: 12px;
    line-height: 14px;
    text-align: left;
    .lien-didomi {
      display: inline-block;
      color: black;
      text-decoration: underline;
    }
  }

  &:hover,
  &:focus-visible {
    .tooltip-favoris-text {
      visibility: visible;
    }
  }
}

::v-deep .hyperlien-retour svg {
  margin: auto;
}
</style>
